import { AccountSettings } from "@/widgets";

export const AccountSettingsPage = () => {
  return <AccountSettings />;
};
